export function createEmptyRow(numCols: number) {
  return Array.from({ length: numCols }, () => ({ real: 0, objetivo: 0 }));
}

export function fillRealValues(
  items: any[],
  rowKey: string,
  editableData: any,
  monthHeaders: string[],
  rangeFrom: any,
  centerTotals: number[],
  globalTotals: number[],
  gCommonList: (arg: string) => any[]
) {
  items.forEach(item => {
    let monthValue: number | null = null;

    if (item.Mes !== undefined && item.Mes !== null) {
      monthValue = item.Mes;
    } else if (typeof item.Meses === 'string') {
      const parts = item.Meses.split('-');
      if (parts.length > 0) {
        monthValue = parseInt(parts[0].trim(), 10);
      }
    }
    if (monthValue == null || isNaN(monthValue)) {
      console.warn('No se encontró un mes válido en el item:', item);
      return;
    }

    const monthsList = gCommonList('months');
    if (!monthsList[monthValue - 1]) {
      console.warn('No se pudo obtener el mes', monthValue);
      return;
    }
    const mesName = monthsList[monthValue - 1].name;
    const monthIndex = monthHeaders.indexOf(mesName);

    const realVal = Number(item.Cantidad || 0);

    const objetivoVal = (item.ObjectiveVal !== undefined)
      ? Number(item.ObjectiveVal)
      : 0;

    if (item.Anyo === rangeFrom.year && monthIndex !== -1) {
      editableData[rowKey][monthIndex].real += realVal;
      centerTotals[monthIndex] += realVal;
      globalTotals[monthIndex] += realVal;
    }

    const totalIndex = (item.Anyo === rangeFrom.year)
      ? monthHeaders.length
      : monthHeaders.length + 1

    editableData[rowKey][totalIndex].real += realVal;
    centerTotals[totalIndex] += realVal;
    globalTotals[totalIndex] += realVal;

    if (objetivoVal > 0) {
      if (item.Anyo === rangeFrom.year && monthIndex !== -1) {
        editableData[rowKey][monthIndex].objetivo = objetivoVal;
      }
      editableData[rowKey][totalIndex].objetivo += objetivoVal;
    }
  });
}

export function fillSummaryValues(
  items: any[],
  cells: Array<{ real: number; objetivo: number }>,
  monthHeaders: string[],
  rangeFrom: any,
  gCommonList: (arg: string) => any[]
) {
  items.forEach((item) => {
    let monthValue: number | null = null;
    if (item.Mes !== undefined && item.Mes !== null) {
      monthValue = item.Mes;
    } else if (typeof item.Meses === 'string') {
      const parts = item.Meses.split('-');
      if (parts.length > 0) {
        monthValue = parseInt(parts[0].trim());
      }
    }
    if (monthValue == null || isNaN(monthValue)) {
      console.warn('No se encontró un mes válido en el item:', item);
      return;
    }

    const monthsList = gCommonList('months');
    if (!monthsList[monthValue - 1]) {
      console.warn('No se pudo obtener el nombre del mes para el valor:', monthValue);
      return;
    }

    const mesName = monthsList[monthValue - 1].name;
    const monthIndex = monthHeaders.indexOf(mesName);

    if (item.Anyo === rangeFrom.year && monthIndex !== -1) {
      cells[monthIndex].real += item.Cantidad;
      if (item.ObjectiveVal !== undefined) {
        cells[monthIndex].objetivo += item.ObjectiveVal;
      }
    }

    const totalIndex = item.Anyo === rangeFrom.year
      ? monthHeaders.length
      : monthHeaders.length + 1;

    cells[totalIndex].real += item.Cantidad;
    if (item.ObjectiveVal !== undefined) {
      cells[totalIndex].objetivo += item.ObjectiveVal;
    }
  });
}

export function applyObjectivesToSummary(objResult: any, summaryJson: any) {
  const actualData = objResult.actual;

  for (const centro in actualData) {
    if (!Object.prototype.hasOwnProperty.call(actualData, centro)) continue;

    const objItems = actualData[centro];
    if (!Array.isArray(objItems)) continue;

    let mainItems = summaryJson.actual[centro];
    if (!Array.isArray(mainItems)) {
      mainItems = [];
      summaryJson.actual[centro] = mainItems;
    }

    objItems.forEach((objItem: any) => {
      const found = mainItems.find(
        (main: any) =>
          main.ModeloDn === objItem.ModeloDn &&
          main.Anyo === objItem.Anyo &&
          main.Mes === objItem.Mes
      );

      if (found) {
        found.ObjectiveVal = objItem.Cantidad;
      } else {
        mainItems.push({
          ModeloDn: objItem.ModeloDn,
          Anyo: objItem.Anyo,
          Mes: objItem.Mes,
          Cantidad: 0,
          ObjectiveVal: objItem.Cantidad,
          centro: centro,
          Marca: objItem.Marca,
          dealer: objItem.dealer,
          manufacturer_id: objItem.manufacturer_id,
          model: objItem.ModeloDn
        });
      }
    });
  }
}
